import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { T } from "@/constants/testIds";

export default function LatestBibleStudies() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/bible-studies?limit=4").then((r) => setItems(r.data || [])).catch(() => setItems([]));
  }, []);

  return (
    <section data-testid={T.bibleStudies} className="bg-forest text-background py-24 sm:py-32">
      <div className="container-editorial">
        <div className="flex items-end justify-between gap-4 mb-12">
          <div>
            <span className="eyebrow text-gold-light">Bible Studies</span>
            <h2 className="heading-2 mt-3 text-background">
              Go deeper in <em className="italic text-gold-light">Scripture</em>.
            </h2>
          </div>
          <Link to="/bible-studies" className="hidden sm:inline text-sm uppercase tracking-widest text-background hover:text-gold-light">
            All studies →
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((s) => (
            <Link
              key={s.id}
              to={`/bible-studies/${s.slug}`}
              data-testid={T.studyCard(s.slug)}
              className="group border border-background/15 p-6 hover:border-gold-light transition-colors flex flex-col"
            >
              <span className="eyebrow text-gold-light">
                {s.testament === "old" ? "Old Testament" : "New Testament"} · {s.study_type}
              </span>
              <h3 className="font-serif text-xl mt-3 text-background group-hover:text-gold-light transition-colors" style={{ fontWeight: 500 }}>
                {s.title}
              </h3>
              <p className="text-sm mt-3 text-background/70 leading-relaxed flex-1">{s.summary}</p>
              <span className="mt-6 text-xs uppercase tracking-widest text-background group-hover:text-gold-light">Read study →</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
